import https from 'hub-http/clients/apiClient';
import { UserAttributesClient } from 'frontend-preferences-client';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';
import { getHubUsersKey, getOwnedAddressesKey
// @ts-expect-error untyped dependency
} from 'FormsUI/earlyRequest/earlyRequestsShared';
const BASE_URL_V2 = 'users/v2/app';
const BASE_URL_EMAIL_OWNERSHIP = 'email-ownership/v1';
export const _fetchHubUsers = () => https.get(`${BASE_URL_V2}/hub-users`);
const userAttributesClient = UserAttributesClient.forCaller('FormsUI');
export const getHubUsers = () => getFromEarlyRequest(getHubUsersKey(), _fetchHubUsers);
const _fetchOwnedAddresses = () => https.get(`${BASE_URL_EMAIL_OWNERSHIP}/owned-addresses`);
export const getOwnedAddresses = () => getFromEarlyRequest(getOwnedAddressesKey(), _fetchOwnedAddresses);
export function getUserAttribute(attributeKey) {
  return userAttributesClient.fetch(attributeKey, 'false');
}
export function updateUserAttribute(attributeKey, attributeValue) {
  return userAttributesClient.write(attributeKey, attributeValue);
}